import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";

import SwitchToggle from "../UI/SwitchToggle";
import Breadcrumb from "../UI/Breadcrumb";

import DeactivateDialog from "./DeactivateDialog";
import PromptDialog from "./PromptDialog";

import SearchForm from "../UI/SearchForm";
import Pagination from "../UI/Pagination";

import { getList, editList } from "../../actions";

class CustomerMenuList extends Component {
  state = {
    page: 1,
    searchedValue: null,
    isDeactivateDialogOpen: false,
    isDeletingDialogOpen: false,
    isCancelDeactivationDialogOpen: false,
    deactivatingListId: null,
    deletingListId: null,
    cancelingDeactivationListId: null
  };

  componentDidMount() {
    const { menuId } = this.props.match.params;
    this.props.getList(menuId, 1, null); // menuId, page, searchedValue
  }

  openDeactivateDialog = (listId, isActive) => {
    if (isActive) {
      this.setState({
        isDeactivateDialogOpen: true,
        deactivatingListId: listId
      });
    } else {
      this.changeStatus(listId, true);
    }
  };

  cancelDeactivation = () => {
    const data = { deactivation_date: null };
    this.props
      .editList(this.state.cancelingDeactivationListId, data)
      .then(res => {
        const { menuId } = this.props.match.params;
        this.props.getList(menuId, this.state.page, this.state.searchedValue);
      });
    this.setState({
      isCancelDeactivationDialogOpen: false,
      cancelingDeactivationListId: null
    });
  };

  changeStatus = (listId, status, date) => {
    const data = {};
    if (date) {
      data.deactivation_date = moment(date).format("YYYY-MM-DD");
    } else {
      data.is_active = status;
    }
    this.props.editList(listId, data).then(res => {
      const { menuId } = this.props.match.params;
      this.props.getList(menuId, this.state.page, this.state.searchedValue);
    });
  };

  onSubmitDeactivateStatusHandler = values => {
    if (
      values.deactivate &&
      values.deactivate === "deactivate_from" &&
      values.date
    ) {
      this.changeStatus(this.state.deactivatingListId, false, values.date);
    } else {
      this.changeStatus(this.state.deactivatingListId, false);
    }
    this.setState({ isDeactivateDialogOpen: false });
  };

  deleteList = () => {
    const data = { is_deleted: true };
    this.props.editList(this.state.deletingListId, data).then(res => {
      const { menuId } = this.props.match.params;
      this.props.getList(menuId, this.state.page, this.state.searchedValue);
    });
    this.setState({ isDeletingDialogOpen: false, deletingListId: null });
  };

  onSubmitSearchHandler = searchValue =>
    this.props.getList(this.props.match.params.menuId, 1, searchValue);

  pageChangeHandler = page =>
    this.props.getList(this.props.match.params.menuId, page.selected + 1, null);

  renderLists = () => {
    let lists = null;
    const { data } = this.props;
    const { menuId } = this.props.match.params;
    if (data && data.lists && data.result && data.tags) {
      lists = data.result.map(listId => {
        const list = data.lists[listId];
        let deactivationDate = null;

        if (list.deactivationDate) {
          deactivationDate = (
            <p>
              <span className="color-grey50">Deactivated from: </span>
              <span className="color-primary ml-5">
                {list.deactivationDate}
              </span>
            </p>
          );
        }
        return (
          <li className="card" key={list.id}>
            <div className="inner with-top">
              <div className="inner-top">{deactivationDate}</div>
              <div>
                <h2>{list.name}</h2>
                <ul className="tags text-center mt-10">
                  {list.tags.map(tagId => (
                    <li key={tagId}>{data.tags[tagId].name}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="options text-center flex-center-y justify-between">
              <Link
                to={"/menu/" + menuId + "/list/" + list.id + "/item"}
                className="pointer"
              >
                View Items
              </Link>
              <div
                onClick={() =>
                  this.openDeactivateDialog(list.id, list.isActive)
                }
              >
                <SwitchToggle notForm toggled={list.isActive} />
              </div>
            </div>
            <div className="action">
              {list.deactivationDate && (
                <Link
                  to="#"
                  onClick={() =>
                    this.setState({
                      isCancelDeactivationDialogOpen: true,
                      cancelingDeactivationListId: list.id
                    })
                  }
                >
                  <span className="cancel">&#10006;</span>
                </Link>
              )}
              {/* <Link
                to="#"
                className="color-red"
                onClick={() =>
                  this.setState({
                    isDeletingDialogOpen: true,
                    deletingListId: list.id
                  })
                }
              >
                <span className="trash fa fa-trash" />
              </Link> */}
            </div>
          </li>
        );
      });
    }
    return lists;
  };

  render() {
    let pagination = null;
    if (
      this.props.data &&
      this.props.data.pageCount &&
      this.props.data.pageCount > 1
    ) {
      pagination = (
        <Pagination
          pageChangeHandler={this.pageChangeHandler}
          pageCount={this.props.data.pageCount}
        />
      );
    }
    return (
      <React.Fragment>
        <div className="page-title">
          <div className="container">
            <div className="row flex-center-y justify-between">
              <div className="col-xs-9 text-left">
                <h1 className="color-grey">Item List</h1>
              </div>
              <SearchForm onSubmit={this.onSubmitSearchHandler} />
            </div>
          </div>
        </div>
        <div className="container">
          <Breadcrumb
            from={[{ link: "/menu", label: "Menu Settings" }]}
            current="List"
          />
        </div>

        <div className="container inner-padding box py-15">
          <div className="box-body">
            <ul className="card-items large">{this.renderLists()}</ul>
            {pagination}
          </div>
        </div>

        <DeactivateDialog
          open={this.state.isDeactivateDialogOpen}
          close={() => this.setState({ isDeactivateDialogOpen: false })}
          onSubmitDialog={this.onSubmitDeactivateStatusHandler}
        />

        <PromptDialog
          open={this.state.isCancelDeactivationDialogOpen}
          prompt={"Are you sure you want to cancel the deactivation?"}
          close={() => this.setState({ isCancelDeactivationDialogOpen: false })}
          changeStatus={this.cancelDeactivation}
        />

        <PromptDialog
          open={this.state.isDeletingDialogOpen}
          prompt={"Are you sure you want to delete the list?"}
          close={() => this.setState({ isDeletingDialogOpen: false })}
          changeStatus={this.deleteList}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.foodna
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getList: (menuId, page, searchValue) =>
      dispatch(getList(menuId, page, searchValue)),
    editList: (listId, data) => dispatch(editList(listId, data))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerMenuList);



// WEBPACK FOOTER //
// ./src/components/Customer-web-portal/List.js